import React, { useEffect, useRef, useState } from "react";
import './style.css';
import tabsData from '../../consts/KeyFeatures';
import Spline from '@splinetool/react-spline';

const KeyFeaturesTabView = () => {
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [tabUnderlineWidth, setTabUnderlineWidth] = useState(0);
    const [tabUnderlineLeft, setTabUnderlineLeft] = useState(0);

    // const Images = [
    //     require('../../assets/responsive.png'),
    //     require('../../assets/mobile-friendly.png'),
    //     require('../../assets/supportive.png')
    // ];

    const animations = [
        "https://prod.spline.design/UkY78b7nhSFXAawh/scene.splinecode",
        "https://prod.spline.design/PlaUZILYJujmeI9l/scene.splinecode",
        "https://prod.spline.design/MqKTr2tZcWxHbgjo/scene.splinecode"
    ];


    const tabsRef = useRef([]);

    useEffect(() => {
        // Function to switch tabs automatically every 3 seconds
        const intervalId = setInterval(() => {
            setActiveTabIndex(prevIndex => (prevIndex + 1) % tabsData.length);
        }, 8000);

        return () => clearInterval(intervalId); // Cleanup function to clear interval when component unmounts

    }, []); // Dependency array is empty, so it runs only once when component mounts

    useEffect(() => {
        // Function to update tab position
        function setTabPosition() {
            const currentTab = tabsRef.current[activeTabIndex];
            setTabUnderlineLeft(currentTab?.offsetLeft ?? 0);
            setTabUnderlineWidth(currentTab?.clientWidth ?? 0);
        }

        setTabPosition(); // Initial call to set tab position

        window.addEventListener("resize", setTabPosition); // Event listener for resize

        return () => window.removeEventListener("resize", setTabPosition); // Cleanup function to remove event listener

    }, [activeTabIndex]); // Dependency array with activeTabIndex

    return (
        <div>
            <div className="tab-container relative">
                <div className="flex space-x-3 border-b wid">
                    {tabsData.map((tab, idx) => (
                        <button
                            key={idx}
                            ref={(el) => (tabsRef.current[idx] = el)}
                            className={`tab-view-btns ${idx === activeTabIndex ? 'active' : ''}`}
                            onClick={() => setActiveTabIndex(idx)}>
                            {tab.label}
                        </button>
                    ))}
                </div>
                <span
                    className="tab-underline block"
                    style={{ left: tabUnderlineLeft, width: tabUnderlineWidth }}
                />
            </div>
            <div className="keyfeatures-container">
            <div className="py-4">
                <p>{tabsData[activeTabIndex].content}</p>
            </div>
            <div className="key-features-image-container">
            {/* <img src={Images[activeTabIndex]} alt="Desktop" className="key-featureimage-container" /> */}
            <Spline scene={animations[activeTabIndex]} className='key-featureimage-container'/>

            </div>
            </div>
        </div>
    );
}

export default KeyFeaturesTabView;
